import React, { useState } from 'react';
import tracking from '../../assets/TruckDeliveryService.gif';
import { Backdrop, Typography } from '@mui/material';

interface LoadingDialogProps {
    open: boolean;
}

const TrackingLoading: React.FC<LoadingDialogProps> = ({
    open,
}) => {
    return (
        //zIndex: (theme) => theme.zIndex.drawer + 1
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1301 }} open={open} >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img src={tracking} alt="Loading..." style={{ width: '150px', height: '150px' }} />
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Fetching the latest tracking information from the carrier...
                </Typography>
            </div>
        </Backdrop>
    );
};

export default TrackingLoading;